/**
 * Utility functions for handling cookies
 */

/**
 * Get cookie value by name
 */
export function getCookie(name: string): string | null {
  const nameEQ = name + "=";
  const decodedCookie = decodeURIComponent(document.cookie);
  const ca = decodedCookie.split(";");

  for (let i = 0; i < ca.length; i++) {
    let c = ca[i];
    while (c.charAt(0) === " ") {
      c = c.substring(1);
    }
    if (c.indexOf(nameEQ) === 0) {
      return c.substring(nameEQ.length, c.length);
    }
  }
  return null;
}

/**
 * Set a cookie with name, value and expiration days
 */
export function setCookie(
  name: string,
  value: string,
  expirationValue: number = 30,
  expirationUnit: "days" | "hours" | "minutes" = "days"
): void {
  const date = new Date();
  switch (expirationUnit) {
    case "days":
      date.setTime(date.getTime() + expirationValue * 24 * 60 * 60 * 1000);
      break;
    case "hours":
      date.setTime(date.getTime() + expirationValue * 60 * 60 * 1000);
      break;
    case "minutes":
      date.setTime(date.getTime() + expirationValue * 60 * 1000);
      break;
  }
  const expires = "expires=" + date.toUTCString();
  document.cookie = name + "=" + value + ";" + expires + ";path=/";
}

/**
 * Remove cookie by name
 */
export function removeCookie(name: string): void {
  // Try different combinations to ensure cookie is removed
  document.cookie = name + "=; expires=Thu, 01 Jan 1970 00:00:00 UTC; path=/;";
  document.cookie = name + "=; expires=Thu, 01 Jan 1970 00:00:00 UTC; path=/; domain=" + window.location.hostname + ";";
  document.cookie =
    name + "=; expires=Thu, 01 Jan 1970 00:00:00 UTC; path=/; domain=." + window.location.hostname + ";";
}
